export async function autoUnlockPending(listingId) {
  if (!listingId) return;

  try {
    await fetch(
      `${process.env.REACT_APP_API_URL}/api/listings/${listingId}/unlock-if-pending`,
      { method: "POST" }
    );
  } catch (err) {
    console.error("autoUnlock error", err);
  }
}
